import gql from 'graphql-tag';

// courseIds is not supported yet in this schema
// https://coursera.atlassian.net/browse/GATS-140
export default gql`
  query CdsPartnerInfoQuery($shortName: String!) {
    PartnersV1Resource {
      shortName(shortName: $shortName, limit: 1) {
        partners: elements {
          id
          shortName
          courseIds
          name
          description
          squareLogo
          landingPageBanner
          instructors(limit: 100) {
            elements {
              id
              fullName
              photo
              shortName
              title
              displayOnPartnerPage
            }
          }
          links {
            website
            twitter
            facebook
            youtube
          }
          specializations {
            elements {
              id
            }
          }
        }
      }
    }
  }
`;
